import React, { useContext } from 'react'
import { TabMenu, TabMenuButton } from 'oio-react'
import PropTypes from 'prop-types'
import { useRouteMatch } from 'react-router-dom'
import { useOrganization } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeNav = ({ backgroundColor }) => {
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)
   const { organization } = useOrganization()
   const customPages = initiative.customPages.filter(p => p.published)
   const { highlightColor } = organization.theme

   // TODO: Add back when we have subinitiatives working nicely (Ref: #262)
   // const enabledSubinitiatives = initiative.subInitiativeTypes.filter(t => t.enabled)

   const navTabs = [{
      name: `${initiative.type.nameSingular} Home`,
      linkTo: match.url,
      exact: true
   }].concat(customPages.map(page => ({
      name: page.title,
      linkTo: `${match.url}/pages/${page.slug}`
   })))

   // TODO: Add back when we have subinitiatives working nicely (Ref: #262)
   // .concat(enabledSubinitiatives.map(s => ({
   //    name: s.namePlural,
   //    linkTo: `${match.url}/s/${s.id}`
   // })))

   if (initiative.appsPeopleEnabled) {
      navTabs.push({
         name: 'People',
         linkTo: `${match.url}/people`
      })
   }

   if (initiative.appsFilesEnabled) {
      navTabs.push({
         name: 'Files',
         linkTo: `${match.url}/files`
      })
   }

   if (initiative.class === 'event' && initiative.appsScheduleEnabled) {
      navTabs.push({
         name: 'Schedule',
         linkTo: `${match.url}/schedule`
      })
   }

   return (
      <TabMenu
         backgroundColor={backgroundColor}
         buttonPaddingHorizontal="0px"
         buttonSpacing="25px"
         buttonSize="xl"
         buttonTextSize="2"
         highlightColor={highlightColor}>
         {navTabs.map(button => (
            <TabMenuButton
               key={button.linkTo}
               name={button.name}
               linkTo={button.linkTo}
               linkExact={button.exact}
            />
         ))}
      </TabMenu>
   )
}

InitiativeNav.propTypes = {
   backgroundColor: PropTypes.string
}

InitiativeNav.defaultProps = {
   backgroundColor: '#fff'
}

export default InitiativeNav
